export default __webpack_public_path__ + "static/media/ecclesia_logo_horizontal_big.d6ecb0a1.png";